import { Box, Button, Grid } from '@mui/material';
import { useState } from 'react';
import { imgUrl } from 'src/Helpers/utils/Constant';
import { ISingleAdmin } from 'src/Types/module/admin/adminTypes';
import { getStatusLabel } from 'src/Utils/Combined';
import { CommonTypoGraphy } from 'src/components/pdfAndImageView/CommonTypoGraphy';
import PdfAndImageView from 'src/components/pdfAndImageView/PdfAndImageView';
import CommonDetailItem, {
  formatValue,
} from 'src/components/CommonDetailItem/CommonDetailItem';

const labelWidth = { xs: '120px', sm: '140px', md: '160px' };

const SingleDetailsinfo = ({ singleAdmin }: { singleAdmin: ISingleAdmin }) => {
  const [imageViewOpen, SetImageViewOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  const {
    user_admin_email,
    user_admin_photo,
    user_admin_role_name,
    user_admin_status,
    user_admin_phone,
    user_admin_name,
    user_admin_zone_name,
    user_admin_president_signature,
    user_admin_secretary_signature,
    user_admin_principle_signature,
  } = singleAdmin || {};

  const statusLabel = user_admin_status
    ? getStatusLabel(user_admin_status)
    : 'N/A';

  const zoneValue = user_admin_zone_name ? (
    <Button variant='outlined' size='small'>
      {user_admin_zone_name}
    </Button>
  ) : (
    'N/A'
  );

  const presidentSig = user_admin_president_signature ? (
    <CommonTypoGraphy
      name='View president signature'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(user_admin_president_signature);
      }}
    />
  ) : (
    'N/A'
  );

  const secretarySig = user_admin_secretary_signature ? (
    <CommonTypoGraphy
      name='View secretary signature'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(user_admin_secretary_signature);
      }}
    />
  ) : (
    'N/A'
  );

  const principleSig = user_admin_principle_signature ? (
    <CommonTypoGraphy
      name='View principle signature'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(user_admin_principle_signature);
      }}
    />
  ) : (
    'N/A'
  );

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Grid
          container
          spacing={{ lg: 5, md: 3, sm: 2 }}
          columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
        >
          <Grid lg={4} item>
            <img
              width={150}
              height={200}
              style={{
                borderRadius: '10px',
                objectFit: 'cover',
              }}
              src={
                user_admin_photo
                  ? `${imgUrl}/${user_admin_photo}`
                  : '/static/images/avatars/avatar2.png'
              }
              alt='Admin Profile'
            />
          </Grid>
          <Grid lg={8} sm={8} md={8} item>
            <Grid container spacing={2}>
              <CommonDetailItem
                label='Name'
                value={formatValue(user_admin_name)}
                labelWidth={labelWidth}
                xs={12}
                sm={6}
                md={6}
              />
              <CommonDetailItem
                label='Role'
                value={formatValue(user_admin_role_name)}
                labelWidth={labelWidth}
                xs={12}
                sm={6}
                md={6}
              />
              <CommonDetailItem
                label='Status'
                value={statusLabel}
                labelWidth={labelWidth}
                xs={12}
                sm={6}
                md={6}
              />
              <CommonDetailItem
                label='Phone'
                value={formatValue(user_admin_phone)}
                labelWidth={labelWidth}
                xs={12}
                sm={6}
                md={6}
              />
              <CommonDetailItem
                label='Email'
                value={formatValue(user_admin_email)}
                labelWidth={labelWidth}
                xs={12}
                sm={6}
                md={6}
              />
              <CommonDetailItem
                label='Zone'
                value={zoneValue}
                labelWidth={labelWidth}
                xs={12}
                sm={6}
                md={6}
              />

              {presidentSig && user_admin_president_signature && (
                <CommonDetailItem
                  label='President Sig'
                  value={presidentSig}
                  labelWidth={labelWidth}
                  xs={12}
                  sm={6}
                  md={6}
                />
              )}

              {secretarySig && user_admin_secretary_signature && (
                <CommonDetailItem
                  label='Secretary Sig'
                  value={secretarySig}
                  labelWidth={labelWidth}
                  xs={12}
                  sm={6}
                  md={6}
                />
              )}

              {principleSig && user_admin_principle_signature && (
                <CommonDetailItem
                  label='Principle Sig'
                  value={principleSig}
                  labelWidth={labelWidth}
                  xs={12}
                  sm={6}
                  md={6}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <PdfAndImageView
        setOpen={SetImageViewOpen}
        open={imageViewOpen}
        file={imageFile}
      />
    </>
  );
};

export default SingleDetailsinfo;
